export const postCodeMaskRegexp = (mask: string): RegExp => {
  const map: { [key: string]: string } = {
    9: '\\d',
    A: '[A-Z]',
    a: '[a-z]',
    X: '[A-Za-z0-9]',
    '?': '\\S',
  };

  const escaped = mask.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = escaped.replace(/9|A|a|X|\?/g, m => map[m] ?? m);

  return new RegExp(`^${pattern}$`);
};
